<script setup>
import {v4 as uuidv4} from "uuid"
import {computed} from "vue"

const props = defineProps({
  modelValue: {
    type: [Number, String],
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  validator: {
    type: Object,
    default: () => {
    }
  },
  error: {
    type: String,
    default: ''
  }
})

const errorMessage = computed(() => {
  if (props.validator?.$errors.length) {
    return props.validator.$errors.map(
      error => error.$message
    ).join(',')
  }

  return props.error
})

defineEmits(['update:modelValue'])

const id = computed(() => `input-${uuidv4()}`)

</script>

<template>
  <div class="input-group">
    <label v-if="label" :for="id" class="input-label">
      {{ label }}
    </label>
    <input
      :class="{
        'error': !! errorMessage,
      }"
      :id="id"
      :value="modelValue"
      v-bind="$attrs"
      type="datetime-local"
      class="input-group__input"
      @input="$emit('update:modelValue', $event.target.value)"
      @keydown.tab="$emit('update:modelValue', $event.target.value)"
    />
    <label class="input-error" v-if="errorMessage">
      {{ errorMessage}}
    </label>
  </div>
</template>